import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges } from "@angular/core";
import { MatDialog } from "@angular/material";
import { ActivatedRoute } from "@angular/router";
import { NzConfigService } from "ng-zorro-antd";
import { ToastrService } from "ngx-toastr";
import { EnterpriseEntity } from "src/app/core/class/enterpriseEntity";
import { Message } from "src/app/core/class/message";
import { UserEntity } from "src/app/core/class/UserEntity";
import { EnumContractEnterpriseStatus, EnumContractUserRole } from "src/app/core/constants/contract";
import { AutoUserService } from "src/app/core/services/auto-user.service";
import { CommonService } from "src/app/core/services/common.service";
import { DocumentService } from "src/app/core/services/document.service";
import { EnterpriseService } from "src/app/core/services/enterprise.service";
import { BaseComponent } from "src/app/shared/components/base/base.component";
import { EnumRoleUser } from "src/app/core/constants/common"
import { ProcedureComponent } from "src/app/shared/components/procedure/procedure.component";
import { CreateContractService } from "src/app/core/services/create-contract.service";

@Component({
  selector: "app-config-signing-flow-moha",
  templateUrl: "./config-signing-flow-moha.component.html",
  styleUrls: ["./config-signing-flow-moha.component.scss"],
})
export class ConfigSigningFlowMohaComponent
  extends BaseComponent
  implements OnInit, OnChanges {
  @Output() getDefault: EventEmitter<any> = new EventEmitter<any>();
  @Output() changeUseDataForTemplate: EventEmitter<any> = new EventEmitter();
  @Output() setUserSign: EventEmitter<string> = new EventEmitter();
  @Output() DATA_RECORD_USER_PERFORM_SIGN: EventEmitter<any> = new EventEmitter<any>();
  @Output() dataFootNoteChange: EventEmitter<any> = new EventEmitter<any>();
  @Input('record_party_sign') recordPartySign: any[];
  @Input('record_user_perform_sign') recordUserPerformSign: UserEntity[];
  @Input('disabled') disabled: boolean;
  @Input('data_foot_note') dataFootNote: any;
  @Input('selectedServiceType') selectedServiceType: any;
  @Input('viewMode') viewMode: string = '';

  RECORD_PARTY_SIGN: any[] = [];
  RECORD_USER_PERFORM_SIGN: UserEntity[] = [];
  valueSelect = null;
  nzCheckLoadingUser = false;
  nzCheckLoadingUserSign = false;
  filteredUserOptions = [];
  filteredUserSignOptions = [];
  inputUserValue: string;
  inputUserSignValue: string;

  enterpriseIdInDocument: string;

  enumContractEnterpriseStatus = EnumContractEnterpriseStatus;

  roleUser = EnumContractUserRole;
  isFormChanging = false;
  isCheckApprover = false;
  approverNumber: any;
  isValidNoUserExist = false;
  isUserSign = false;
  indexUserSign = -1
  isNotAttestedUser: boolean = false;
  deleteCreateSide: boolean = false;
  RECORD_PARTY_SIGN_TO_BACK_DATA:  any[] = [];
  RECORD_PARTY_SIGN_AterThat:  any[] = [];
  enType: string;
  limitNumberOfPartner = 5;
  public maxNumberOfCustomerInFlow: number = 1;   // số lượng khách hàng tối đa trong luồng

  noteWarning = "";

  checkOrder : boolean = false;

  @Output() maxNumberOfCustomerInFlowOutput = new EventEmitter<number>();

  constructor(
    private documentService: DocumentService,
    public commonService: CommonService,
    public message: Message,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private nzConfigService: NzConfigService,
    private route: ActivatedRoute,
    private enterpriseService: EnterpriseService,
    public autoUserService: AutoUserService,
    private createContractService: CreateContractService,
  ) {
    super(commonService, message);
    this.approverNumber = localStorage.getItem('approverNumber');
    this.limitNumberOfPartner = parseInt(localStorage.getItem('maxCustomerInFileImport') || '5');
    this.isNotAttestedUser = this.commonService.checkEnterpriseType();
  }

  ngOnInit() {
    this.getDefaultEnterprises();
    if (this.recordPartySign && this.recordPartySign.length) {
      this.RECORD_PARTY_SIGN = this.recordPartySign.filter(item => item.isCreatedSide);
      this.recordPartySign = this.RECORD_PARTY_SIGN.filter(item => item.isCreatedSide && item.isCreatedSideJoin);
    }
    if (this.recordUserPerformSign && this.recordUserPerformSign.length) {
      this.RECORD_USER_PERFORM_SIGN = [...this.recordUserPerformSign.map((data) => ({
        ...data,
        signConfig: typeof data.signConfig === 'string' ? JSON.parse(data.signConfig) : data.signConfig
      }))];
    }
    this.enType = localStorage.getItem('entType');
    if (this.viewMode !== 'view') {
      this.createContractService.recordsUserPerformSign.subscribe(res => {
        this.RECORD_USER_PERFORM_SIGN = res;
        this.isUserSign = true;
        const checkUserSign = this.RECORD_USER_PERFORM_SIGN.filter(item => item.role === EnumRoleUser.USER_SIGN);
        if (checkUserSign.length > 0) {
          this.isUserSign = true;
          this.indexUserSign = this.RECORD_USER_PERFORM_SIGN.indexOf(checkUserSign[0])
        } else {
          this.isUserSign = false;
          this.indexUserSign = -1;
        }

        const checkApprover = this.RECORD_USER_PERFORM_SIGN.filter(item => item.role === EnumRoleUser.USER_APPROVER);
        if (checkApprover.length === Number(this.approverNumber)) {
          this.isCheckApprover = true;
        } else {
          this.isCheckApprover = false;
        }
      })
    }

    this.noteWarning = this.commonService.format(this.message.getMessage('contract_lot.note_warning'), this.limitNumberOfPartner)
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.recordPartySign && changes.recordPartySign.currentValue) {
      this.RECORD_PARTY_SIGN = changes.recordPartySign.currentValue.filter((item: any) => item.isCreatedSide);
      this.recordPartySign = this.RECORD_PARTY_SIGN.filter(item => { return item.isCreatedSide && item.isCreatedSideJoin });
    }
    if (changes && changes.recordUserPerformSign && changes.recordUserPerformSign.currentValue) {
      this.RECORD_USER_PERFORM_SIGN = changes.recordUserPerformSign.currentValue.map((data) => ({
        ...data,
        signConfig: typeof data.signConfig === 'string' ? JSON.parse(data.signConfig) : data.signConfig
      }));
      this.RECORD_USER_PERFORM_SIGN.forEach(item => item.role += '');
      this.isUserSign = true;
      const checkUserSign = this.RECORD_USER_PERFORM_SIGN.filter(item => item.role === EnumRoleUser.USER_SIGN);
      if (checkUserSign.length > 0) {
        this.isUserSign = true;
        this.indexUserSign = this.RECORD_USER_PERFORM_SIGN.indexOf(checkUserSign[0])
      } else {
        this.isUserSign = false;
        this.indexUserSign = -1;
      }

      const checkApprover = this.RECORD_USER_PERFORM_SIGN.filter(item => item.role === EnumRoleUser.USER_APPROVER);
      if (checkApprover.length === Number(this.approverNumber)) {
        this.isCheckApprover = true;
      } else {
        this.isCheckApprover = false;
      }
    }
  }

  onChangeOrderOfPartySign() {}

  onChangeMaxNumberOfParty() {
    if(!this.maxNumberOfCustomerInFlow){
      this.maxNumberOfCustomerInFlow = 1;
    }

    this.maxNumberOfCustomerInFlowOutput.emit(this.maxNumberOfCustomerInFlow);
  }

  setFormChanging(changingStatus: boolean): void {
    this.isFormChanging = changingStatus;
  }

  onSelectCustomerForTemplate(id: any, value: boolean) {
    this.setFormChanging(true);
    if (value) {            // Nếu chọn 1 khách hàng để bind information into template
      if (id != null) {
        // Re-set những khách hàng khác là ko được chọn bind information into template
        this.RECORD_PARTY_SIGN = this.RECORD_PARTY_SIGN.map((item) => {
          return {
            ...item,
            useDataForTemplate: item.customerId === id
          };
        });
      }
    }
  }
  changeChanKy(data){
    if(data.signConfig){
      data.signConfig = '{"showImage":true}'
    }
    else data.signConfig =data.signConfig = '{"showImage":false}'
  }

  onChangeUserRole() {
    this.validateErrorSetUser();
  }

  onClickDeleteElementRecordUser(userId: any) {
    let RECORD_USER_PERFORM_SIGN = this.RECORD_USER_PERFORM_SIGN.filter(d => d.userId !== userId);
    // RECORD_USER_PERFORM_SIGN = RECORD_USER_PERFORM_SIGN.map((item, index) => (
    //   {
    //     ...item,
    //     order: 1
    //   }));

    const checkUserSign = RECORD_USER_PERFORM_SIGN.filter(item => item.role === EnumRoleUser.USER_SIGN);
        if (checkUserSign.length > 0) {
          this.isUserSign = true;
          this.indexUserSign = RECORD_USER_PERFORM_SIGN.indexOf(checkUserSign[0])
        } else {
          this.isUserSign = false;
          this.indexUserSign = -1;
        }
    const checkUserApprover = RECORD_USER_PERFORM_SIGN.filter(item => item.role === EnumRoleUser.USER_APPROVER);
    if (checkUserApprover.length === Number(this.approverNumber)) {
      this.isCheckApprover = true;
    } else {
      this.isCheckApprover = false;
    }
    if (RECORD_USER_PERFORM_SIGN.length > 0 && checkUserSign.length > 0 && !this.deleteCreateSide) {
      // RECORD_USER_PERFORM_SIGN[RECORD_USER_PERFORM_SIGN.length - 1].role = this.roleUser.SIGN + '';
      this.setUserSign.emit(checkUserSign[0].name);
    } else {
      this.setUserSign.emit(null);
      this.isValidNoUserExist = true;
    }
    if (this.dataFootNote && this.dataFootNote.length > 0) {
      this.dataFootNote.map(item => {
        if (item.signature && item.userId && item.userId === userId) {
          item.userId = null;
        }
      });
    }
    this.DATA_RECORD_USER_PERFORM_SIGN.emit(RECORD_USER_PERFORM_SIGN);
    this.RECORD_USER_PERFORM_SIGN = RECORD_USER_PERFORM_SIGN;

    this.setFormChanging(true);
    this.validateErrorSetUser();

  }

  changeCTS(event, user) {
    if ((user && !user.isSignDigitalCertificate) && !event) {
      if (this.dataFootNote && this.dataFootNote.length > 0) {
        this.dataFootNote.map(item => {
          if (item.signature && item.userId && item.userId === user.userId) {
            item.userId = null;
          }
        });
      }
    }
    this.DATA_RECORD_USER_PERFORM_SIGN.emit(this.RECORD_USER_PERFORM_SIGN);
    this.setFormChanging(true);
  }

  changeDisplaySignature() {
    this.DATA_RECORD_USER_PERFORM_SIGN.emit(this.RECORD_USER_PERFORM_SIGN);
    this.setFormChanging(true);
  }

  onChangeUserSearch(_event) {
    if (this.inputUserValue && this.inputUserValue.trim().length > 0) {
      this.nzCheckLoadingUser = true;
      this.autoUserService.fetchAuto(this.inputUserValue.trim())
        .then(result => {
          this.filteredUserOptions = result;
        }).finally(() => {
          this.nzCheckLoadingUser = false;
        });
    } else {
      this.inputUserValue = '';
      this.filteredUserOptions = [];
    }
  }
  
  onChangeUserSignSearch(_event) {
    if (this.inputUserSignValue && this.inputUserSignValue.trim().length > 0) {
      this.nzCheckLoadingUserSign = true;
      this.autoUserService.fetchAuto(this.inputUserSignValue.trim())
        .then(result => {
          this.filteredUserSignOptions = result;
        }).finally(() => {
          this.nzCheckLoadingUserSign = false;
        });
    } else {
      this.inputUserSignValue = '';
      this.filteredUserSignOptions = [];
    }
  }

  autocompleteUserSelected($event: any, model: any) {
    this.setFormChanging(true);
    if ($event.isUserInput) {
      if (!this.checkExistedUser(model.id, model.name, model.email)) {
        // Re-set all old members to "APPROVE" role
        let RECORD_USER_PERFORM_SIGN = this.RECORD_USER_PERFORM_SIGN;

        RECORD_USER_PERFORM_SIGN = [
          ...RECORD_USER_PERFORM_SIGN,
          {
            order: RECORD_USER_PERFORM_SIGN.filter((data) => data.role == EnumRoleUser.USER_APPROVER).length ? RECORD_USER_PERFORM_SIGN.filter((data) => data.role == EnumRoleUser.USER_APPROVER)[RECORD_USER_PERFORM_SIGN.filter((data) => data.role == EnumRoleUser.USER_APPROVER).length - 1].order + 1 : 1,
            userId: model.id,
            enterpriseSignId: this.enterpriseIdInDocument,
            name: model.name,
            email: model.email,
            role: this.roleUser.APPROVE + '',
            phone: model.phone,
            isSignDigitalCertificate: model.isSignDigitalCertificate ? model.isSignDigitalCertificate : false,
            isCreatedSide: true,
            signConfig: model.signConfig ? this.setDataSignConfig(JSON.parse(model.signConfig)) : { resize: false, showImage: model.isSignDigitalCertificate ? true : (this.roleUser.APPROVE + '' == EnumRoleUser.USER_SIGN ? true : false) },
            userPosition: model.userPosition
          }
        ];
        this.inputUserValue = '';
        // this.isValidNoUserExist = false;
        this.RECORD_USER_PERFORM_SIGN = RECORD_USER_PERFORM_SIGN;
        this.DATA_RECORD_USER_PERFORM_SIGN.emit(RECORD_USER_PERFORM_SIGN);
        this.indexUserSign = RECORD_USER_PERFORM_SIGN.length - 1;
        const checkUserSign = this.RECORD_USER_PERFORM_SIGN.filter(item => item.role === EnumRoleUser.USER_SIGN);
        if (checkUserSign.length > 0) {
          this.isUserSign = true;
          this.indexUserSign = this.RECORD_USER_PERFORM_SIGN.indexOf(checkUserSign[0])
        } else {
          this.isUserSign = false;
          this.indexUserSign = -1;
        }

        const checkApprover = this.RECORD_USER_PERFORM_SIGN.filter(item => item.role === EnumRoleUser.USER_APPROVER);
        if (checkApprover.length === Number(this.approverNumber)) {
          this.isCheckApprover = true;
        } else {
          this.isCheckApprover = false;
        }
        // this.setUserSign.emit(model.name);
      }
    }
  }

  autocompleteUserSignSelected($event: any, model: any) {
    this.setFormChanging(true);
    if ($event.isUserInput) {
      if (!this.checkExistedUser(model.id, model.name, model.email)) {
        // Re-set all old members to "APPROVE" role
        let RECORD_USER_PERFORM_SIGN = this.RECORD_USER_PERFORM_SIGN;

        RECORD_USER_PERFORM_SIGN = [
          ...RECORD_USER_PERFORM_SIGN,
          {
            order: 1,
            userId: model.id,
            enterpriseSignId: this.enterpriseIdInDocument,
            name: model.name,
            email: model.email,
            role: this.roleUser.SIGN + '',
            phone: model.phone,
            isSignDigitalCertificate: model.isSignDigitalCertificate ? model.isSignDigitalCertificate : false,
            isCreatedSide: true,
            signConfig: model.signConfig ? this.setDataSignConfig(JSON.parse(model.signConfig)) : { resize: false, showImage: model.isSignDigitalCertificate ? true : (this.roleUser.SIGN + '' == EnumRoleUser.USER_SIGN ? true : false) },
            userPosition: model.userPosition
          }
        ];
        this.inputUserValue = '';
        this.isValidNoUserExist = false;
        this.RECORD_USER_PERFORM_SIGN = RECORD_USER_PERFORM_SIGN;
        this.isUserSign = true;
        this.indexUserSign = RECORD_USER_PERFORM_SIGN.length - 1;
        this.setUserSign.emit(model.name);
        this.DATA_RECORD_USER_PERFORM_SIGN.emit(RECORD_USER_PERFORM_SIGN);
      }
    }
  }

  getDefaultEnterprises() {
    // => push element first to array nếu nó không phải đang edit
    this.enterpriseIdInDocument = localStorage.getItem('enterpriseId');
    this.enterpriseService.getEnterpriseByID(this.enterpriseIdInDocument).subscribe(rs => {
      if (rs && rs.data && !this.RECORD_PARTY_SIGN.length) {
        this.RECORD_PARTY_SIGN = [
          {
            enterpriseId: rs.data.id || '',
            order: 1,
            email: rs.data.email || '',
            enterpriseName: '',
            phone: rs.data.phone || '',
            status: this.enumContractEnterpriseStatus.NO_PROCESS,
            isCreatedSide: true,
            customerId: '',
            name: rs.data.name || '',
            certificateNo: (rs.data.taxCode && rs.data.taxCode.length > 0) ? rs.data.taxCode : rs.data.certificateNo,
            useDataForTemplate: true,
            isSignNoLogin: rs.data.isSignNoLogin,
            isCreatedSideJoin: true,
            signConfig: rs.data.signConfig ? this.setDataSignConfig(JSON.parse(rs.data.signConfig)) : { resize: false, showImage: true }
          }
        ];
        this.getDefault.emit(this.RECORD_PARTY_SIGN);
        this.recordPartySign = this.RECORD_PARTY_SIGN.filter(item => { return item.isCreatedSide && item.isCreatedSideJoin });
      }
    }, (error) => console.log(error));

  }

  checkExistedUser(id: string, fullname: string, email: string) {
    const existedList = this.RECORD_USER_PERFORM_SIGN.filter((e) => {
      return e.userId === id;
    });

    if (existedList.length > 0) {
      if (existedList[0].role === EnumRoleUser.USER_SIGN) {
        this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_user_apostrophe_duplicate_sign'), [fullname + ' - ' + email]));
      } else {
        this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_user_apostrophe_duplicate_approve'), [fullname + ' - ' + email]));
      }
      return true;
    } else {
      return false;
    }
  }

  public validateErrorSetUser(model?) {
    // khi chủ thể không có chủ thể đang đăng nhập thì không kiểm tra user nữa
    const checkCurrentEnterprise = this.RECORD_PARTY_SIGN.filter(item => item.isCreatedSide === true && item.isCreatedSideJoin);
    if (checkCurrentEnterprise.length === 0) {
      this.isValidNoUserExist = false;
      return false;
    }

    const userPerform = this.RECORD_USER_PERFORM_SIGN.filter(item => item.role === EnumRoleUser.USER_SIGN);
    const checkDeleteCreateSide = this.recordPartySign.filter(item=> item.deleteCreateSide)
    // Kiểm tra trong list ko chua User nào?null
    if (userPerform.length === 0 && checkDeleteCreateSide.length===0) {
      this.isValidNoUserExist = true;
      setTimeout(() => {
        if (document.getElementById('inputUserSign')) {
          document.getElementById('inputUserSign').scrollIntoView();
          document.getElementById('inputUserSign').focus();
        }
      }, 300);
      return true;
    } else {
      this.isValidNoUserExist = false;
    }
    const checkUserSign = this.RECORD_USER_PERFORM_SIGN.filter(item => item.role === EnumRoleUser.USER_SIGN);
    if (checkUserSign.length === 0) {
      this.isValidNoUserExist = true;
    }
    return false;
  }

  checkShowTableUser() {
    let check = false;
    this.RECORD_PARTY_SIGN.forEach(item => {
      if (item.isCreatedSide && item.isCreatedSideJoin) {
        check = true;
      }
    });
    return check;
  }

  // onChangeUseDataForTemplate() {
  //   const isCreatedSide = this.RECORD_PARTY_SIGN.find(item => item.isCreatedSide);
  //   if (isCreatedSide) {
  //     isCreatedSide.isCreatedSideJoin = !isCreatedSide.isCreatedSideJoin;
  //   }
  //   this.recordPartySign = this.RECORD_PARTY_SIGN.filter(item => { return item.isCreatedSide && item.isCreatedSideJoin });
  //   if (isCreatedSide.isCreatedSideJoin) {
  //     this.changeUseDataForTemplate.emit(isCreatedSide);
  //   } else {
  //     this.changeUseDataForTemplate.emit(null);
  //   }
  //   this.DATA_RECORD_USER_PERFORM_SIGN.emit(this.RECORD_USER_PERFORM_SIGN);
  // }

  isDisabledAddCreateSide() {
    const createSide = this.recordPartySign.find(item => item.isCreatedSide);
    return createSide ? true : false;
  }

  setColspan(maximumSpan: number): number {
    // if (this.isNotAttestedUser) maximumSpan -= 1;

    return maximumSpan;
  }

  onChangeOrderApproveSign() {
    this.setFormChanging(true);
  }

  setDataSignConfig(signConfig: any) {
    let newDataSignConfig = { ...signConfig };
    if(newDataSignConfig.resize === null || newDataSignConfig.resize === undefined) {
      newDataSignConfig = { ...newDataSignConfig, resize: false };
    }
    if(newDataSignConfig.showImage === null || newDataSignConfig.showImage === undefined) {
      newDataSignConfig = { ...newDataSignConfig, showImage: true };
    }
    return newDataSignConfig;
  }

  onClickDeleteElementRecordParty(enterpriseId: any, customerId: any) {
    this.RECORD_PARTY_SIGN_TO_BACK_DATA =this.recordPartySign;
    this.RECORD_PARTY_SIGN_AterThat = this.RECORD_PARTY_SIGN
    if (enterpriseId && enterpriseId.length > 0) {
      this.recordPartySign = this.recordPartySign.filter(d => d.enterpriseId !== enterpriseId);
    } else {
      this.recordPartySign = this.recordPartySign.filter(d => d.customerId !== customerId);
    }
    let orderCounter = 1;
    this.recordPartySign = this.recordPartySign .map(item => { item.order = orderCounter++; return item });
    this.recordPartySign.push({deleteCreateSide: true });
    this.deleteCreateSide=true;
    this.isUserSign = false;
    this.indexUserSign = -1;
    this.isCheckApprover = false;
    this.setUserSign.emit(null);
    this.isValidNoUserExist = true;
    this.DATA_RECORD_USER_PERFORM_SIGN.emit([]);
    this.RECORD_USER_PERFORM_SIGN =[];
    this.RECORD_PARTY_SIGN =this.recordPartySign.filter(item=> !item.deleteCreateSide)

  }

  comBack() {
     this.isValidNoUserExist = false;
    let orderCounter=1;
    this.recordPartySign = this.RECORD_PARTY_SIGN_TO_BACK_DATA.filter(item => { return item.isCreatedSide && item.isCreatedSideJoin });
    this.recordPartySign  =  this.recordPartySign.map(item => { item.order = orderCounter++; return item });
    this.deleteCreateSide=false;
   this.RECORD_PARTY_SIGN =this.RECORD_PARTY_SIGN_AterThat;
  }
  openDialogProcedure(type: number, $event) {
    $event.stopPropagation();
    const dialogRef = this.dialog.open(ProcedureComponent, {
      width: '70%',
      data: {
        type: type,
        internalFlowNotEdit: this.selectedServiceType ? this.selectedServiceType.internalFlowNotEdit : null
      }
    })

    dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        // this.resetSignPosition.emit();
      }
    });
  }

  checkUserSign() : boolean{
    return this.RECORD_PARTY_SIGN.some((item : any) => !!item.customerType);
 }

 checkOrderUnique() {
   const orders = this.RECORD_USER_PERFORM_SIGN
     .filter((item : any) => item.role == 2 || item.role == '2')
     .map((item: any) => item.order)
     .filter((order: any) => order !== null && order !== undefined);
 
   const countMap = new Map<number, number>();
   let checkCount = false;
   for (const order of orders) {
     countMap.set(order, (countMap.get(order) || 0) + 1);
     if (countMap.get(order)! > 1) {
       checkCount = true;
     }
   }
   
   if(checkCount == true){
   this.checkOrder = true;
   }else{
     this.checkOrder = false;
   }
 }

//  checkOrderUserSign() {
//    this.checkOrderUnique();
//    const orders = this.RECORD_PARTY_SIGN
//      .map((item: any) => item.order)
//      .filter((order: any) => order !== null && order !== undefined);
 
//    const countMap = new Map<number, number>();
 
//    for (const order of orders) {
//      countMap.set(order, (countMap.get(order) || 0) + 1);
//      if (countMap.get(order)! > 1) {
//        return true;
//      }
//    }
 
//    return false;
//  }
}
